module.exports = __webpack_public_path__ + "static/media/stop.92eab596.svg";